<template>
  <div :class="['chat__detail', show && 'active', isGroup && 'group']">
    <div class="chat__detail-header">
      <div class="mt-1">
        <button type="button" class="btn-action" @click="$emit('back')">
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.43819 9.00093L11.0379 15.6005L9.15233 17.4861L0.666992 9.00093L9.15233 0.515625L11.0379 2.40124L4.43819 9.00093Z"
              fill="white"
            />
          </svg>
        </button>
      </div>

      <div v-if="isGroup" class="chat__contact-header__profile">
        <span class="chat__contact-header__profile-name">{{ name }}</span>

        <div
          v-if="groupSelected && groupSelected.agent_group"
          class="avatar-group"
        >
          <a
            v-for="item in groupSelected.agent_group.filter((r, i) => i < 3)"
            :key="item.id"
            href="javascript:void(0)"
            class="avatar-group-item"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-placement="top"
            :title="item.user_platform.name"
          >
            <ImgLazy
              v-if="item.user_platform.picture"
              :src="item.user_platform.picture"
              :alt="item.user_platform.name"
              errorImg="/img/user-dummy-img.jpg"
              style="width: 25px; height: 25px; border-radius: 50%"
            />
            <div
              v-else
              :class="`rounded-circle avatar-xxs d-inline-flex justify-content-center align-items-center text-uppercase ${getRandomColor(
                false,
                dataUser?.color || 0
              )}`"
            >
              <div>
                {{ getSortName(item.user_platform.name) }}
              </div>
            </div>
          </a>

          <a
            v-if="groupSelected.agent_group.length > 3"
            href="#addmemberModal"
            data-bs-toggle="modal"
            class="avatar-group-item"
          >
            <div class="avatar-xxs">
              <div
                style="
                  font-size: 0.8em;
                  color: black;
                  font-weight: 700;
                  background-color: #e6eef9;
                "
                class="avatar-title rounded-circle"
              >
                +{{ groupSelected.agent_group.length - 3 }}
              </div>
            </div>
          </a>
        </div>
      </div>

      <div v-else class="chat__detail-header__profile">
        <div class="img-profile">
          <ImgLazy
            v-if="image"
            :src="image"
            :alt="name"
            errorImg="/img/user-dummy-img.jpg"
          />
          <div
            v-else
            :class="[
              'd-flex h-100 w-100 justify-content-center align-items-center text-uppercase',
              getRandomColor(true, dataUser?.color || 0),
            ]"
            style="font-size: 1.4rem"
          >
            {{ getSortName(name) }}
          </div>
        </div>

        <div>
          <span class="chat__detail-header__profile-name">
            {{ dataUser?.user.name || "" }}
          </span>
          <span>{{ isOnline ? "Online" : "Offline" }}</span>
        </div>
      </div>

      <div class="mt-1">
        <button
          v-if="!isGroup"
          type="button"
          class="btn-action"
          @click="$emit('minimize')"
        >
          <svg
            width="14"
            height="2"
            viewBox="0 0 14 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0V2H14V0H0Z" fill="white" />
          </svg>
        </button>
      </div>
    </div>

    <div id="chatBody" class="chat__detail-body">
      <template v-for="r in chatList" :key="r">
        <div v-if="r.fromId === user" class="chat__detail-body-sender">
          <div class="message">
            <template
              v-for="(messageItem, messageKey) in r.messages"
              :key="`${r._id}-${messageKey}`"
            >
              <span
                v-if="typeof messageItem === 'string'"
                v-html="formatMessage(messageItem)"
              >
              </span>

              <a
                v-else-if="typeof messageItem === 'object'"
                :href="messageItem.media.url"
                class="message-document"
                target="_blank"
              >
                <span class="message-document__icon">
                  <i class="ri-file-3-fill"></i>
                </span>

                <div>
                  <span>{{ messageItem.media.filename }}</span>
                </div>
              </a>
            </template>
            {{ r.createdAt }}
          </div>
        </div>

        <div v-else class="chat__detail-body-receiver">
          <template v-if="isGroup">
            <img v-if="image" :src="image" :alt="name" />
            <img
              v-else
              src="../assets/images/users/user-dummy-img.jpg"
              :alt="name"
            />
          </template>

          <div class="message">
            <template
              v-for="(messageItem, messageKey) in r.messages"
              :key="`${r._id}-${messageKey}`"
            >
              <span
                v-if="typeof messageItem === 'string'"
                v-html="formatMessage(messageItem)"
              >
              </span>

              <a
                v-else-if="typeof messageItem === 'object'"
                :href="messageItem.media.url"
                class="message-document"
                target="_blank"
              >
                <span class="message-document__icon">
                  <i class="ri-file-3-fill"></i>
                </span>

                <div>
                  <span>{{ messageItem.media.filename }}</span>
                </div>
              </a>
            </template>
            {{ r.createdAt }}
          </div>
        </div>
      </template>

      <div id="chatBodyBottom"></div>
    </div>

    <div class="chat__detail-form">
      <div class="attachment-list">
        <span v-if="media" class="attachment-item">
          <button type="button" class="remove-attachment" @click="media = null">
            <i class="ri-add-line"></i>
          </button>

          <span>{{ media.origin_filename }}</span>
        </span>
      </div>

      <div
        class="position-absolute"
        :style="`
          bottom: 50px;
          left: 20px;
          transition: all 300ms ease-in-out;
          ${
            !showEmoji
              ? 'transform: translateY(50px); opacity: 0; pointer-events: none'
              : ''
          }
        `"
      >
        <EmojiPicker :native="true" @select="selectedIcon" />
      </div>

      <button type="button" class="btn-action" @click="showEmoji = !showEmoji">
        <i class="ri-emotion-happy-line"></i>
      </button>

      <label class="btn-action btn-action-attachment">
        <input ref="fileEl" type="file" @change="handleFile" />
        <i class="ri-attachment-line"></i>
      </label>

      <input
        v-model="message"
        type="text"
        class="input"
        :placeholder="placeholder"
        @keydown="handleKeydownSend"
      />

      <button type="button" class="btn-send" @click="send">
        <i class="ri-send-plane-2-line"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch, computed, ref } from "vue";
import EmojiPicker from "vue3-emoji-picker";
import { useStore } from "vuex";
import axios from "axios";

import { FilesystemService } from "@/services";

import ImgLazy from "./base/ImgLazy.vue";

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  toId: {
    type: [String, Number],
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  color: {
    type: Number,
    default: 0,
  },
  image: {
    type: String,
    default: null,
  },
  isGroup: {
    type: Boolean,
    required: true,
  },
  chats: {
    type: Array,
    required: true,
  },
  statusLogin: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["back", "minimize", "send", "openMedia"]);

const store = useStore();

const placeholder = computed(
  () => `Message to "${props.name}" ${props.isGroup ? "Group" : ""}`
);

const message = ref("");
const showEmoji = ref(false);

const user = computed(() => store.state["localStorage"].decodedUserId);
const groups = computed(() => store.getters["internalChat/getGroups"]);
const groupSelected = computed(() => {
  if (!props.toId) return null;

  return groups.value.find((r) => r.id === props.toId);
});

const dataUser = computed(() => {
  const data = store.getters["internalChat/getContactList"].find(
    (r) => r.user_id.toString() === props.toId.toString()
  );

  return data;
});

const isOnline = computed(() => {
  const check = store.getters["internalChat/getOnlineMembers"].find(
    (r) => r.userId === props.toId
  );

  return check?.status || false;
});

const chatList = computed(() => {
  const data = [];
  props.chats.forEach((r) => {
    const messages = [];
    if (r.media_url && r.media_filename && r.media_origin_filename) {
      messages.push({
        media: {
          url: r.media_url,
          filename: r.media_filename,
          origin_filename: r.media_origin_filename,
        },
      });
    }
    messages.push(r.message);

    if (data.length) {
      if (data[data.length - 1] && data[data.length - 1].fromId === r.fromId) {
        data[data.length - 1].messages = [
          ...data[data.length - 1].messages,
          ...messages,
        ];
        data[data.length - 1].createdAt = formatTime(r.createdAt);
      } else {
        data.push({
          ...r,
          messages,
          createdAt: formatTime(r.createdAt),
        });
      }
    } else {
      data.push({
        ...r,
        messages: [r.message],
        createdAt: formatTime(r.createdAt),
      });
    }
  });

  return data;
});

const fileEl = ref();
const media = ref(null);

const handleFile = async () => {
  if (fileEl.value?.files.length) {
    const form = new FormData();

    const ext = fileEl.value.files[0].name.split(".").pop();
    const randomFilename = `${Date.now()}.${ext}`;
    const originFilename = fileEl.value.files[0].name;

    form.append("file", fileEl.value.files[0], randomFilename);
    form.append("channel", "internal_chat");

    try {
      const req = await FilesystemService.uploadFile(form);

      console.log({
        filename: randomFilename,
        origin_filename: originFilename,
        url: req.data.data.fileUrl,
      });

      media.value = {
        filename: randomFilename,
        origin_filename: originFilename,
        url: req.data.data.fileUrl,
      };
      console.log(media.value);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.log("Error uploading file:", error.response);
      }
      console.log(error);
    }
  }
};

const selectedIcon = (icon) => {
  message.value = message.value + icon.i;
};

const formatTime = (str) => {
  const now = new Date();
  const date = new Date(str);

  const prefix = (num) => (num > 9 ? num : `0${num}`);

  if (
    now.getFullYear() === date.getFullYear() &&
    now.getMonth() === date.getMonth() &&
    now.getDate() === date.getDate()
  ) {
    return `${prefix(date.getHours())}:${prefix(date.getMinutes())}`;
  }

  return `${date.getDate()}/${
    date.getMonth() + 1
  }/${date.getFullYear()} ${prefix(date.getHours())}:${prefix(
    date.getMinutes()
  )}`;
};

const send = () => {
  emit("send", message.value, media.value);
  showEmoji.value = false;

  message.value = "";
  media.value = null;
};

const handleKeydownSend = (e) => {
  if (e.keyCode === 13) send();
};

const scrollDown = () => {
  const body = document.getElementById("chatBody");
  const bodyBottom = document.getElementById("chatBodyBottom");

  if (body) {
    body.scrollTo({
      top: bodyBottom.offsetTop,
      behavior: "smooth",
    });
  }
};

const colors = ["success", "warning", "danger", "info"];

const getRandomColor = (soft = false, index = null) => {
  let randomIndex =
    index === null ? Math.floor(Math.random() * colors.length) : index;

  return `bg-${soft ? "soft-" : ""}${colors[randomIndex]} ${
    soft ? `text-${colors[randomIndex]}` : "text-white"
  }`;
};

const getSortName = (name = "") => {
  const split = name.split(" ");
  if (split.length > 1) {
    return `${split[0][0]}${split[1][0]}`;
  }
  return name.substr(0, 2);
};

const formatMessage = (str = "") => {
  return str
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(
      /(\b(?:https?|ftp):\/\/\S+)/gi,
      '<a href="$1" target="_blank">$1</a>'
    );
};

watch(
  () => props.toId,
  () => {
    scrollDown();
  }
);

watch(
  () => props.chats,
  () => {
    setTimeout(() => {
      scrollDown();
    }, 200);
  }
);

onMounted(() => {
  scrollDown();
});
</script>